import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "is-flex is-justify-content-space-between is-align-items-center" }
const _hoisted_3 = { class: "field is-grouped" }
const _hoisted_4 = { class: "control" }
const _hoisted_5 = { class: "control" }
const _hoisted_6 = { class: "is-flex is-justify-content-space-between is-align-items-center mb-2" }
const _hoisted_7 = { style: {"flex":"1 1 auto","min-width":"0"} }
const _hoisted_8 = { class: "box" }
const _hoisted_9 = { class: "codemirror-wrapper" }
const _hoisted_10 = {
  key: 0,
  class: "is-flex is-justify-content-space-between is-align-items-center"
}
const _hoisted_11 = {
  key: 0,
  class: "field is-grouped"
}
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "control" }
const _hoisted_14 = {
  key: 1,
  class: "box build-logs"
}
const _hoisted_15 = { class: "logs-inner" }
const _hoisted_16 = ["onClick", "innerHTML"]
const _hoisted_17 = ["aria-label"]
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { class: "has-text-centered" }
const _hoisted_20 = { class: "is-size-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_breadcrumb_item = _resolveComponent("b-breadcrumb-item")!
  const _component_InlineNameEditor = _resolveComponent("InlineNameEditor")!
  const _component_b_breadcrumb = _resolveComponent("b-breadcrumb")!
  const _component_b_button = _resolveComponent("b-button")!
  const _component_b_icon = _resolveComponent("b-icon")!
  const _component_b_tab_item = _resolveComponent("b-tab-item")!
  const _component_codemirror = _resolveComponent("codemirror")!
  const _component_b_tabs = _resolveComponent("b-tabs")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_b_select = _resolveComponent("b-select")!
  const _component_b_message = _resolveComponent("b-message")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.project)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_b_breadcrumb, {
              size: "is-large",
              separator: "has-succeeds-separator",
              "aria-label": "breadcrumbs"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_b_breadcrumb_item, {
                  tag: "a",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.goToList()), ["prevent"]))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('projects.title')), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_b_breadcrumb_item, {
                  tag: "span",
                  active: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_InlineNameEditor, {
                      "model-value": _ctx.project?.name || _ctx.id,
                      "can-edit": !!_ctx.project,
                      placeholder: _ctx.$t('projects.name'),
                      save: _ctx.saveProjectName
                    }, null, 8, ["model-value", "can-edit", "placeholder", "save"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_b_button, {
                  type: "is-primary",
                  "icon-left": "content-save",
                  disabled: !_ctx.anyDirty,
                  title: _ctx.$t('projects.saveTooltip'),
                  onClick: _ctx.saveAll
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('projects.save')), 1)
                  ]),
                  _: 1
                }, 8, ["disabled", "title", "onClick"])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_b_button, {
                  type: "is-info",
                  "icon-left": "hammer",
                  loading: _ctx.building,
                  title: _ctx.$t('projects.buildTooltip'),
                  onClick: _ctx.buildAll
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('projects.build')), 1)
                  ]),
                  _: 1
                }, 8, ["loading", "title", "onClick"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_b_tabs, {
                modelValue: _ctx.currentPath,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.currentPath) = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_b_tab_item, { value: '__new__' }, {
                    header: _withCtx(() => [
                      _createVNode(_component_b_icon, { icon: "file-plus-outline" }),
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('projects.addFile')), 1)
                    ]),
                    _: 1
                  }),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredFiles, (f) => {
                    return (_openBlock(), _createBlock(_component_b_tab_item, {
                      key: f.path,
                      value: f.path,
                      lazy: true
                    }, {
                      header: _withCtx(() => [
                        _createVNode(_component_b_icon, {
                          icon: _ctx.fileIcon(f.path)
                        }, null, 8, ["icon"]),
                        _createElementVNode("span", {
                          class: _normalizeClass({ 'has-text-weight-bold': _ctx.isDirty(f.path) })
                        }, _toDisplayString(f.name), 3),
                        _createVNode(_component_b_icon, {
                          icon: "close",
                          size: "is-small",
                          onClick: _withModifiers(($event: any) => (_ctx.confirmRemoveFile(f.path)), ["stop"])
                        }, null, 8, ["onClick"])
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("div", _hoisted_9, [
                            _createVNode(_component_codemirror, {
                              "model-value": _ctx.fileStates[f.path]?.content ?? '',
                              "onUpdate:modelValue": ($event: any) => (_ctx.onContentChange(f.path, $event)),
                              style: { height: '75vh', width: '100%' },
                              "indent-with-tab": true,
                              "tab-size": 2,
                              extensions: _ctx.cmExtensionsFor(f.path),
                              onReady: ($event: any) => (_ctx.onEditorReady(f.path, $event))
                            }, null, 8, ["model-value", "onUpdate:modelValue", "extensions", "onReady"])
                          ])
                        ])
                      ]),
                      _: 2
                    }, 1032, ["value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          (_ctx.buildResult)
            ? (_openBlock(), _createBlock(_component_b_message, {
                key: 0,
                type: _ctx.buildResult?.success ? 'is-success' : 'is-danger',
                class: "mt-2"
              }, {
                default: _withCtx(() => [
                  (_ctx.buildResult?.success)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createElementVNode("div", null, [
                          _createTextVNode(_toDisplayString(_ctx.$t('projects.buildSucceeded')) + " — ", 1),
                          (_ctx.firmwareSha)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createVNode(_component_router_link, {
                                  to: { name: 'firmware-details', params: { sha: _ctx.firmwareSha } }
                                }, {
                                  default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                                    _createTextVNode("firmware.bin", -1)
                                  ]))]),
                                  _: 1
                                }, 8, ["to"]),
                                _createTextVNode(" (" + _toDisplayString(_ctx.formatSize(_ctx.firmwareArtifact.size)) + ") ", 1)
                              ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(" firmware.bin (" + _toDisplayString(_ctx.formatSize(_ctx.firmwareArtifact.size)) + ") ", 1)
                              ], 64))
                        ]),
                        (_ctx.firmwareArtifact)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                              _createVNode(_component_b_select, {
                                modelValue: _ctx.selectedDeviceId,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedDeviceId) = $event)),
                                placeholder: _ctx.$t('projects.selectDevice')
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.deviceList, (d) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                      key: d.id,
                                      value: d.id
                                    }, _toDisplayString(d.name || d.id), 9, _hoisted_12))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue", "placeholder"]),
                              _createElementVNode("div", _hoisted_13, [
                                _createVNode(_component_b_button, {
                                  type: "is-danger",
                                  "icon-left": "fire",
                                  loading: _ctx.building,
                                  title: _ctx.$t('projects.flashTooltip'),
                                  onClick: _ctx.flashFirmware
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('projects.flash')), 1)
                                  ]),
                                  _: 1
                                }, 8, ["loading", "title", "onClick"])
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(_ctx.$t('projects.buildFailed')), 1)
                      ], 64))
                ]),
                _: 1
              }, 8, ["type"]))
            : _createCommentVNode("", true),
          (_ctx.buildLogs !== null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.buildLogLines, (line, idx) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: idx,
                      class: "is-family-monospace is-size-7",
                      style: {"white-space":"pre"},
                      onClick: ($event: any) => (_ctx.onLogLineClick(line, $event)),
                      innerHTML: _ctx.buildLogLinesHtml[idx]
                    }, null, 8, _hoisted_16))
                  }), 128)),
                  (_ctx.building && !_ctx.buildResult)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "typing-dots",
                        "aria-live": "polite",
                        "aria-label": _ctx.$t('projects.building')
                      }, [...(_cache[5] || (_cache[5] = [
                        _createElementVNode("span", null, null, -1),
                        _createElementVNode("span", null, null, -1),
                        _createElementVNode("span", null, null, -1)
                      ]))], 8, _hoisted_17))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.$t('projects.notFound')), 1),
            _createVNode(_component_b_button, {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.goToList())),
              class: "mt-4"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('global.back')), 1)
              ]),
              _: 1
            })
          ])
        ]))
  ]))
}